import { ModelSummary } from 'core/ModelSummary'
import { indexBy, prop } from 'ramda'
import { ModelSummaries } from './db'

export async function getIndexedModelSummaries(): Promise<{
  [id: string]: ModelSummary
}> {
  return await ModelSummaries.toArray().then(indexBy(prop('id')))
}
